import {h, Component, Fragment} from 'preact';
import PFeed from "../../../services/prematch-feed";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as I from "../utils/icons.jsx";
import AwrabetMenuTopleagues from '../../awrabet/desktop-components/menu-topleagues.jsx';

export default class MenuTopleagues extends AwrabetMenuTopleagues {
    render({callback}) {
        return !!this.state.topleagues.length && <div>
			<M.MenuTitleCentered>Top Leagues</M.MenuTitleCentered>
			<div>
                {this.state.topleagues.map(league => <M.TopLeagueButton onClick={e => !!callback? this.clickCallbackFunction(league, callback) : false}>
					<M.TournamentFlagIcon category={PFeed.NStorage.get(league.parent)} tournament={league} />
					<M.CircleSeparator />
					{/*<M.SportFlagIcon sport={PFeed.getWithParents(league.parent).sport} />*/}
					<M.LeagueNameLabel>{league.name}</M.LeagueNameLabel>
					<M.SportFlagIcon sport={PFeed.getWithParents(league.parent).sport} />
                </M.TopLeagueButton>)}
			</div>
		</div>;
    }
}